import { Component, OnInit, AfterContentChecked, ViewChild, ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationService } from 'src/app/shared/services/application.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AccommodationWelfareDetails, Carer, AccommodationWelfareUpdateDetails } from '../models/accommodation-welfare-details';
import { ApiResponse, SingleResultApiResponse } from 'src/app/shared/models/api-response.model';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Action_ApplicationSectionSaved } from '../state/actions';
import { ErrorResponse } from 'src/app/shared/models/error.model';
import { ModalService } from 'src/app/shared/services/modal.service';
import { Observable } from 'rxjs';
import { compareAccommodationDetails } from '../shared/utils/ModelUtils';
import { slideInOut } from '../animations/slideInOut';
import { FormService } from 'src/app/shared/services/form.service';
import { Title } from '@angular/platform-browser';
import { Tab_Title } from 'src/app/shared/models/lookup-data.model';

@Component({
  selector: 'online-app-accommodation-welfare',
  templateUrl: './accommodation-welfare.component.html',
  styleUrls: ['./accommodation-welfare.component.scss'],
  host: {
    class: 'application-section-component'
  },
  animations: [slideInOut]
})
export class AccommodationWelfareComponent implements OnInit, AfterContentChecked {

  accommodationWelfareFormGroup: FormGroup;
  applicationId: number;
  accommodationWelfareDetails: AccommodationWelfareDetails[] = [];
  selectedAccommodationTypeId = 0;
  Carers: Carer[] = [];
  isFormSubmitted = false;
  initialAccommodationWelfareDetails: AccommodationWelfareUpdateDetails;
  isSaveSuccessful = false;
  parentErrorText = '';
  directRelativeErrorText = '';
  parentNominationErrorText = '';
  isScrollDone = false;
  isSubmittedApplication = false;
  showChangeImpactModal: boolean = false;
  isHomestayDisablePeriod: boolean;


  errorKeyFormFieldMapping = [
    { apiErrorKeyName: 'AccommodationTypeId', formFieldName: 'accommodationTypeId', apiValidationErrorMsg: null } ,
    { apiErrorKeyName: 'SelectedCarerId', formFieldName: 'selectedCarerId', apiValidationErrorMsg: null },
  ];

  @ViewChild('resolve') resolve: ElementRef;

  constructor(private fb: FormBuilder,
    private router: Router,
    private store: Store<any>,
    private modalService: ModalService,
    private formService: FormService,
    private activatedRoute: ActivatedRoute,
    private applicationService: ApplicationService, 
    private titleService: Title) {
      this.activatedRoute.parent.params.subscribe( params => {
        this.applicationId = +params['id'];
     });
     }

  ngOnInit() {
    if(localStorage.getItem("isAgent") == "true"){
      this.titleService.setTitle(Tab_Title.Agent_AccommodationAndWelfare_Title);
    }else{
      this.titleService.setTitle(Tab_Title.AccommodationAndWelfare_Title);
    }
    this.accommodationWelfareFormGroup = this.fb.group({
      accommodationTypeId: 0,
      selectedCarerId: 0
    });

    this.applicationService.getAccommodationWelfareDetails(this.applicationId)
        .subscribe( (response: ApiResponse) => {
          //console.log('response: ', response);
          this.accommodationWelfareDetails = <AccommodationWelfareDetails[]>response.Result;
          //console.log('this.accommodationWelfareDetails: ', this.accommodationWelfareDetails);
          this.updateFormValuesFromAccommodationDetails(this.accommodationWelfareDetails);
          this.initialAccommodationWelfareDetails = this.getAccommodationWelfareUpdateDetails();
          //console.log('getAccommodationWelfareDetails: ', this.initialAccommodationWelfareDetails);
        }, err => {
          console.error(err);
        });

      this.applicationService.getApplicationDetails(this.applicationId)
    .subscribe( (response: SingleResultApiResponse) => {
      if (response.Result) {

        this.isSubmittedApplication = response.Result.ApplicationStatus === 'Submitted';

        this.isHomestayDisablePeriod = response.Result.IsHomestayDisablePeriod;

      }
      }, err => {
          console.error(err);
      });

  }

  isNoAccommodationDetailsAvailable(): boolean {
    return this.accommodationWelfareDetails.length === 1 && this.accommodationWelfareDetails[0].AccommodationTypeId === 0;
  }

  updateAccommodationType(accommodationTypeId: number) {

    // if (this.isSubmittedApplication) {
    //   return;
    // }

    //MN-11579 if T1/2 of 2024, do not let them select
    if (accommodationTypeId === 4 && this.isHomestayDisablePeriod)
      return;


    this.selectedAccommodationTypeId = accommodationTypeId;
    this.updateAvailableCarers(accommodationTypeId);

    this.accommodationWelfareFormGroup.patchValue({
      accommodationTypeId: accommodationTypeId
    });

    if (this.Carers.length === 0) {

      if (accommodationTypeId === 1 ) {
        this.parentErrorText = `You cannot select this option as you have NOT created a contact
        with any of the following relationships: Father or Mother.`;
        this.directRelativeErrorText = '';
        this.parentNominationErrorText = '';
      } else if (accommodationTypeId === 2 ) {
        this.parentErrorText = '';

        this.directRelativeErrorText = `You cannot select this option as you have NOT created a contact
          with any of the following relationships and with age 25 years and above based on the Program Start Date :
          Aunt, Brother, Grandparent, Nephew, Niece, Sister, Step - Aunt, Step - brother, Step - father, Step - Grandparent,
          Step - mother, Step - sister, Step - Uncle or Uncle. For information on who is considered a direct relative
          please refer to the Direct Relative Nomination form.`;

        this.parentNominationErrorText = '';
      } else if (accommodationTypeId === 3 ) {
        this.parentErrorText = '';
        this.directRelativeErrorText = '';
        this.parentNominationErrorText = `You cannot select this option as you have NOT created a contact with
         any of the following relationships: Brother-In-Law, Cousin, Family Friend, Other Family or Sister-in-law.
        If you intend to nominate an extended family member or a family friend to act as carer
        for this student, please ensure the person you nominate is 25 years and above.`;
      }

    } else {      
      this.parentErrorText = '';
      this.directRelativeErrorText = '';
      this.parentNominationErrorText = '';
    }

    this.accommodationWelfareFormGroup.updateValueAndValidity();
  }

  updateAvailableCarers(selectedAccommodationTypeId: number) {

    const selectedAccommodationWelfare =
      this.accommodationWelfareDetails.find(awd => awd.AccommodationTypeId === selectedAccommodationTypeId);

    if (selectedAccommodationWelfare) {
      this.Carers = selectedAccommodationWelfare.Carers;
    } else {
      this.Carers = [];
    }

    const selectedCarerId = this.accommodationWelfareFormGroup.get('selectedCarerId').value;
    //console.log(`selectedCarerId:${selectedCarerId}`);

    this.accommodationWelfareFormGroup.patchValue({
      selectedCarerId: this.getSelectedCarer()
    });

  }

  getSelectedCarer(): number {

    const initialSelectedAccommodationType = this.accommodationWelfareDetails.find( awd => awd.IsSelected);

    if (initialSelectedAccommodationType) {
      const initialSelectedCarerId = initialSelectedAccommodationType.SelectedCarerId;

      const selectedCarer = this.Carers.find( c => c.CarerId === initialSelectedCarerId);

      if (selectedCarer) {
        return selectedCarer.CarerId;
      }
    }

    return 0;

  }

  getAccommodationWelfareMetaSectionDesc(): string {
    return this.Carers && this.Carers.length > 0 ? '1 of 2' : '1 of 1';
  }

  previous() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'parent-guardian-details']);
  }
  next() {
    this.router.navigate(['/applications', this.applicationId, 'edit', 'visa-oshc']);
  }

  getCarerMetaDescription(carerId: number): string {

    let carerMetaDescription = '';

    const carer = this.Carers.find(c => c.CarerId === carerId);

    if (carer) {
      if(carer.FamilyName){
        carerMetaDescription = `${carer.Description} - ${carer.FamilyName},  ${carer.GivenName}`;
      }else{
        carerMetaDescription = `${carer.Description} - ${carer.GivenName}`;
      }
    }

    return carerMetaDescription;
  }

  getAccommodationWelfareUpdateDetails(): AccommodationWelfareUpdateDetails {

    const accommodationWelfareUpdateDetails = new AccommodationWelfareUpdateDetails();

    accommodationWelfareUpdateDetails.AccommodationTypeId = this.accommodationWelfareFormGroup.get('accommodationTypeId').value;
    accommodationWelfareUpdateDetails.SelectedCarerId = this.accommodationWelfareFormGroup.get('selectedCarerId').value;


    return accommodationWelfareUpdateDetails;
  }

  setApiValidationError(apiErrorKeyName: string, apiErrorMsg): void {
    //console.log(`In setApiValidationError.apiErrorKeyName: ${apiErrorKeyName}, apiErrorMsg:${apiErrorMsg}`);
    const errorField = this.errorKeyFormFieldMapping.find( errorKeyFormField => errorKeyFormField.apiErrorKeyName === apiErrorKeyName);

    if (errorField) {
      const { formFieldName }  = errorField;
      this.accommodationWelfareFormGroup.get(formFieldName).setErrors({apiValidationError : true});
      errorField.apiValidationErrorMsg = apiErrorMsg;
    }

  }

  updateFormValuesFromAccommodationDetails(accommodationWelfareDetails: AccommodationWelfareDetails[]): void {
    const selectedAccommodationDetail = accommodationWelfareDetails.find( awd => awd.IsSelected);

    if (selectedAccommodationDetail) {
      this.updateAccommodationType(selectedAccommodationDetail.AccommodationTypeId);

      const selectedCarerId = selectedAccommodationDetail.SelectedCarerId;

      this.accommodationWelfareFormGroup.patchValue({
        selectedCarerId
      });

      this.accommodationWelfareFormGroup.updateValueAndValidity();
    }

  }

  canDeactivate(): Observable<boolean> | boolean {

    if (this.isSaveSuccessful) {
      return true;
    }

    if (!this.isAccommodationWelfareDetailsSame()) {
      this.modalService.showModal();
      return this.modalService.stayOnThePage;
    } else {
      this.modalService.hideModal();
      return true;
    }
  }


  isAccommodationWelfareDetailsSame(): boolean {

    const currentAccommodationWelfareDetails = this.getAccommodationWelfareUpdateDetails();
    const initialAccommodationWelfareDetails = this.initialAccommodationWelfareDetails;

    const isAccommodationWelfareDetailsSame =
              compareAccommodationDetails(initialAccommodationWelfareDetails, currentAccommodationWelfareDetails);

    return isAccommodationWelfareDetailsSame;
  }

  saveAndContinue() {
    this.isFormSubmitted = true;

    const accommodationWelfareUpdateDetails = this.getAccommodationWelfareUpdateDetails();

    this.applicationService.updateAccommodationWelfareDetails(this.applicationId, accommodationWelfareUpdateDetails)
        .subscribe( (response: SingleResultApiResponse) => {
          this.dispatchSectionSaveAction();
          this.isSaveSuccessful = true;

          if(response.Result){
            this.showChangeImpactModal = response.Result.IsAccommodationStatusChanged;
          }
          if(this.showChangeImpactModal === false){
            this.router.navigate(['/applications', this.applicationId, 'edit', 'visa-oshc']);
          }else{
            setTimeout(() => {
              this.resolve.nativeElement.focus();
            }, 100);
          }

        }, (errorResponse: ErrorResponse) => {
          const { errors } = errorResponse;
          for (const error of errors) {
            this.setApiValidationError(error.Key, error.Value);
          }
          this.accommodationWelfareFormGroup.updateValueAndValidity();
          this.dispatchSectionSaveAction();
          this.initialAccommodationWelfareDetails = this.getAccommodationWelfareUpdateDetails();
          this.isScrollDone = false;
          this.formService.scrollToFirstErrorField();
      });

  }

  ngAfterContentChecked(): void {
    if (!this.isScrollDone) {
      this.isScrollDone = this.formService.scrollToFirstErrorField();
    }
  }



  getApiValidationErrorMsg(formFieldName: string): string {
    const errorField = this.errorKeyFormFieldMapping.find( errorKeyFormField => errorKeyFormField.formFieldName === formFieldName);
    return errorField.apiValidationErrorMsg ? errorField.apiValidationErrorMsg : '';
  }


  dispatchSectionSaveAction() {
    this.store.dispatch({
      type: Action_ApplicationSectionSaved
    });
  }

  displayChangeImpactModal(): boolean {
    return this.showChangeImpactModal;
  }

  closeChangeImpactModal() {
    this.showChangeImpactModal = false;
    this.router.navigate(['/applications', this.applicationId, 'edit', 'visa-oshc']);
  }

  //accessibility -- link error msg to form field
  errorDoubleErrorAccessibility(formControlName: string, requireErrorId: string, apiErrorId: string): string {
    if (this.isFormSubmitted &&
      this.accommodationWelfareFormGroup.get(formControlName).errors &&
      this.accommodationWelfareFormGroup.get(formControlName).errors.required) {
      return requireErrorId;
    } else if (this.isFormSubmitted &&
      this.accommodationWelfareFormGroup.get(formControlName).errors &&
      this.accommodationWelfareFormGroup.get(formControlName).errors.apiValidationError) {
      return apiErrorId;
    } else {
      return "";
    }
  }
 

}
